import React from "react";
import { BadgeCheck, Leaf, Ban, Stethoscope, Microscope } from "lucide-react";

const CARDS = [
    { icon: BadgeCheck, title: "PCSIR Verified", sub: "Government Approved", gold: true },
    { icon: Leaf, title: "100% Organic", sub: "Rosemary Extract", gold: false },
    { icon: Ban, title: "Paraben Free", sub: "No Harsh Chemicals", gold: true },
    { icon: Stethoscope, title: "Dermatologist", sub: "Approved Formula", gold: false },
];

export default function TrustSection() {
    return (
        <section
            data-testid="trust-section"
            id="pcsir"
            className="py-10 sm:py-14 bg-cream"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-forest-900 rounded-3xl p-7 sm:p-10 text-white relative overflow-hidden shadow-2xl">
                    <div className="absolute -right-10 -bottom-16 opacity-[0.08] text-gold-400 pointer-events-none">
                        <Microscope className="w-[260px] h-[260px]" />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10">
                        <div className="lg:col-span-8 space-y-4">
                            <div className="inline-flex items-center gap-2 bg-gold-500/15 text-gold-400 border border-gold-500/40 px-3.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-widest">
                                <BadgeCheck className="w-3.5 h-3.5" />
                                Pakistan Standard Compliance
                            </div>
                            <h2 className="font-serif text-3xl sm:text-4xl font-bold leading-tight">
                                PCSIR Certified. Lab-Tested. Honestly Natural.
                            </h2>
                            <p className="text-cream/80 text-sm sm:text-base leading-relaxed max-w-2xl">
                                Your scalp deserves ingredients it can trust.
                                Dermalist Rosemary Advanced Hair Growth Serum is
                                independently tested and approved by the{" "}
                                <strong className="text-gold-400">
                                    Pakistan Council of Scientific and
                                    Industrial Research (PCSIR)
                                </strong>
                                . Free from parabens, sulfates, silicones and
                                every chemical filler your hair hates.
                            </p>
                        </div>

                        <div className="lg:col-span-4 grid grid-cols-2 gap-3 sm:gap-4">
                            {CARDS.map(({ icon: Icon, title, sub, gold }) => (
                                <div
                                    key={title}
                                    className="bg-white/10 backdrop-blur-sm p-4 rounded-2xl border border-white/10 text-center transition-colors hover:bg-white/15"
                                >
                                    <Icon
                                        className={`w-7 h-7 mx-auto mb-2 ${
                                            gold
                                                ? "text-gold-400"
                                                : "text-forest-200"
                                        }`}
                                    />
                                    <h3 className="text-[11px] font-bold uppercase tracking-wider text-white">
                                        {title}
                                    </h3>
                                    <p className="text-[11px] text-cream/70 mt-0.5">
                                        {sub}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
